<div *ngIf="isLobbyLoaded && loadWidget && isSlotRaceSubCategory && enableSlotRacesForOtherProducts">
    <div class="casino-npm-sr-title">
        <span [vnDynamicHtml]="header?.text"></span>
        <span class="theme-right" *ngIf="header?.titleLink?.text" (click)="SeeAllTournaments()"></span>
        <span class="casino-sr-npm-see-all" [vnDynamicHtml]="header?.titleLink?.text" (click)="SeeAllTournaments()"> </span>
    </div>
    <cc-slot-races-wrapper [component]="'carousel'" [lobbyType]="lobbyType" [category]="category"> </cc-slot-races-wrapper>
</div>
